/** @format */

import {forwardRef, ReactElement, Ref} from 'react';

import {Tooltip} from '@mui/material';

import {TitleComponent, TitleHotKeyBox, TitleText} from './styles';

interface Props {
  open: boolean;
  children: ReactElement;
}

const HintTooltip = forwardRef(({children, open}: Props, ref: Ref<HTMLDivElement>) => {
  return (
    <Tooltip
      ref={ref}
      title={
        <TitleComponent>
          <TitleHotKeyBox>
            <TitleText>Esc</TitleText>
          </TitleHotKeyBox>
          <TitleText>— отменить изменения</TitleText>
        </TitleComponent>
      }
      open={open}
      disableFocusListener
      disableHoverListener
      disableTouchListener
      disableInteractive
      placement='bottom-start'
      slotProps={{
        popper: {
          modifiers: [
            {
              name: 'offset',
              options: {
                offset: [-10, 18],
              },
            },
          ],
          sx: {
            '.MuiTooltip-tooltipPlacementBottom': {
              background: 'none',
              padding: 0,
            },
          },
        },
      }}
    >
      {children}
    </Tooltip>
  );
});

HintTooltip.displayName = 'HintTooltip';

export {HintTooltip};
